import {
  Button,
  ButtonGroup,
  FormLabel,
  Heading,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  Text,
} from '@chakra-ui/react';
import { useState } from 'react';
import { SelectOption } from '../Form/ReactSelect';

interface IUserAssignmentModalProps {
  categoryOptions: SelectOption[];
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (categoryId: string) => void;
}

export const UserAssignmentModal = ({
  categoryOptions,
  isOpen,
  onClose,
  onConfirm,
}: IUserAssignmentModalProps): JSX.Element => {
  const [selectedCategoryId, setSelectedCategoryId] = useState<string>();

  const handleSubmit = (): void => {
    if (selectedCategoryId) {
      onConfirm(selectedCategoryId);
    }
  };

  return (
    <Modal size="lg" isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />

      <ModalContent>
        <ModalHeader>
          <Heading size="lg" fontWeight="normal">
            Confirmação de vinculação
          </Heading>
        </ModalHeader>

        <ModalCloseButton />

        <ModalBody>
          <Text>
            Já existe usuário cadastrado com esse documento, deseja vincular o
            cadastro existente ao empreendimento selecionado?
          </Text>

          <FormLabel htmlFor="categoryId" mt="8">
            Categoria
          </FormLabel>

          <Select
            name="categoryId"
            borderColor="gray.300"
            bg="gray.100"
            focusBorderColor="blue.300"
            variant="outline"
            size="lg"
            value={selectedCategoryId}
            onChange={(e) => setSelectedCategoryId(e.target.value)}
          >
            {categoryOptions.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </Select>
        </ModalBody>

        <ModalFooter mt="14">
          <ButtonGroup>
            <Button colorScheme="blackAlpha" onClick={onClose}>
              Cancelar
            </Button>

            <Button colorScheme="green" onClick={handleSubmit}>
              Confirmar
            </Button>
          </ButtonGroup>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
